<template>
  <div class="text-options-data-dialog">
    <div
      :class="currentFiledMappingFieldFlag ? 'mapping_content checked' : 'mapping_content'"
    >
      <div class="verticallyBetweenCenter">
        <div class="content-title">
          {{ getValueByTypeHandle(options.innerElement) }}
        </div>
        <div class="verticallyCenter" v-if="options.innerElement == 'cxText' || options.innerElement == 'cxLabel'">
          <el-checkbox v-model="textHyperlink" v-if="options.innerElement == 'cxText'">超链接</el-checkbox>
          <el-checkbox v-model="isHyperlink" v-else>超链接</el-checkbox>
        </div>
      </div>
      <div class="select_content mt8">
        <el-select style="width: 100%" v-model="currentFiledMappingFieldFlag" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in currentFiledMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mapping_date_content mt8">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingType">
          <span class="el-dropdown-link">
            {{ fieldMappingDataTypeName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown">
            <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
              <div :class="fieldMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select_content mt8" v-if="options.isHyperlink">
        <el-select style="width: 100%" v-model="currentFiledMappingFieldFlag" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in currentFiledMappingList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mt4" v-if="options.isHyperlink">
        <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { getValueByType } from "utils"
import dataToolMixin from "materials/dataToolMixin"

export default {
  name: "currentFieldMappingSetting",
  components: {},
  mixins: [dataToolMixin],
  props: {
    myid: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      currentFiledMappingList: [],
      dateOptions: [
        {
          value: "7",
          label: "年-月-日 时:分:秒"
        },
        {
          value: "10",
          label: "年-月-日 时:分"
        },
        {
          value: "1",
          label: "年-月-日"
        },
        {
          value: "2",
          label: "年-月"
        },
        {
          value: "3",
          label: "月-日"
        },
        {
          value: "8",
          label: "时:分"
        },
        {
          value: "4",
          label: "年"
        },
        {
          value: "5",
          label: "月"
        },
        {
          value: "6",
          label: "日"
        },
        {
          value: "9",
          label: "文本格式"
        }
      ],
      detailFiledMappingValue: {},
      isDateFlag: false
    }
  },
  computed: {
    currentFiledMapping() {
      if (!this.options.currentFiledMapping) {
        this.$changeOptionsEV({}, "currentFiledMapping", false, null, {
          ...this.myid
        })
      }
      return this.options.currentFiledMapping
    },
    currentFiledMappingDataType: {
      get() {
        return this.currentFiledMapping.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.myid
        })
      }
    },
    currentFiledMappingLinkField: {
      get() {
        return this.currentFiledMapping.linkField
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.linkField", false, null, {
          ...this.myid
        })
      }
    },
    currentFiledMappingChecked: {
      get() {
        return this.options.currentFiledMapping?.isChecked || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.isChecked", false)
      }
    },
    currentFiledMappingFieldFlag: {
      get() {
        return this.currentFiledMapping.fieldFlag
      },
      set(newVal) {
        if(!this.currentFiledMappingChecked) {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
          this.$changeOptionsEV(true, "currentFiledMapping.isChecked", false, false, false, true)
        } else {
          this.$changeOptionsEV(newVal, "currentFiledMapping.fieldFlag", false)
        }
      }
    },
    currentFiledMappingDateStyle: {
      get() {
        return this.currentFiledMapping.dateStyle || "9"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dateStyle", false, null, {
          ...this.myid
        })
        this.$changeOptionsEV(true, "currentFiledMapping.isDate", false, null, {
          ...this.myid
        })
      }
    },
    currentFiledMappingDateTitle: {
      get() {
        return this.currentFiledMapping.dataType === "dataKey"
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV("dataKey", "currentFiledMapping.dataType", false, null, this.myid)
        } else {
          this.$changeOptionsEV("dataValue", "currentFiledMapping.dataType", false, null, this.myid)
        }
      }
    },
    textHyperlink: {
      get() {
        return this.options.textHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    isHyperlink: {
      get() {
        return this.options.isHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    videoObjectId: {
      get() {
        return this.options.videoObjectId
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "videoObjectId", false, null, {
          ...this.myid
        })
      }
    },
    fieldMappingDataType: {
      get() {
        return this.currentFiledMapping?.dataType || "dataValue"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "currentFiledMapping.dataType", false, null, {
          ...this.ids
        })
      }
    },
    fieldMappingDataTypeName() {
      const item = this.dataTypeList.find(data => data.value === this.fieldMappingDataType)
      return item?.label || ""
    },
  },
  watch: {
    videoObjectId: {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.dataTypeList.push({
            label: "objectId",
            value: "dataObjectId"
          })
        } else {
          this.dataTypeList.splice(3, 1)
        }
      }
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onChangeMappingType(value) {
      this.currentFiledMappingDataType = value
    },
    onChangeMappingDateStyle(value) {
      this.currentFiledMappingDateStyle = value
    },
    onChangeMappingDateTitle(value) {
      this.currentFiledMappingDateTitle = value
    },
    getCurrentFiledMappingList() {
      if (this.options?.noCacheComponent === "3" && this.directionTitle) {
        let classifyData = this.getClassifyData()
        this.currentFiledMappingList = classifyData.filter(item=>{
          return item.value === "iconUrl" || item.value === "topUrl"
        })
      }
    }
  },
  created() {
    this.getCurrentFiledMappingList()
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .vedio-style {
    font-size: 13px;
  }
  .verticallyBetweenCenter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.bigScreen {
  .mapping_content {
    color: rgba(255, 255, 255, 0.8);
    border-color: rgba(255, 255, 255, 0.08);
    background-color: rgba(40, 42, 46, 1);
    &.checked,
    &:hover {
      border-color: rgba(166, 139, 255, 0.16);
      background-color: rgba(166, 139, 255, 0.04);
    }
    .select_content {
      ::v-deep .el-input__inner {
        background-color: rgba(31, 33, 36, 1);
        box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.08) inset;
      }
    }
    &.checked {
      .select_content {
        ::v-deep .el-input__inner {
          background-color: rgba(166, 139, 255, 0.1);
          color: rgba(166, 139, 255, 1);
          box-shadow: 0px 0px 0px 1px rgba(166, 139, 255, 0.16) inset;
          &:hover {
            background-color: rgba(166, 139, 255, 0.2);
          }
        }
        ::v-deep .el-select__caret {
          color: rgba(166, 139, 255, 1);
        }
        ::v-deep .is-focus .el-input__inner {
          background-color: rgba(166, 139, 255, 0.2);
        }
      }
    }
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
